export default __webpack_public_path__ + "static/media/iconoutgoing.d9aefa88.svg";